import { render, staticRenderFns } from "./ImageDisplayer.vue?vue&type=template&id=3b68940c&scoped=true&"
import script from "./ImageDisplayer.vue?vue&type=script&lang=js&"
export * from "./ImageDisplayer.vue?vue&type=script&lang=js&"
import style0 from "./ImageDisplayer.vue?vue&type=style&index=0&id=3b68940c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b68940c",
  null
  
)

export default component.exports